import React from "react";
import { Label } from "Components";
import { MENTOR_AVAILABILITY_COLUMNS } from "../../Managers/DomainManager";
import { HeaderGrid, HeaderCell, MentorHeaderCell, SlotGrid, SlotCell } from "./ScheduleChartHeader.styles";

export const ScheduleChartHeader: React.FC = () => {
    return (
        <HeaderGrid>
            <MentorHeaderCell>
                <Label fontStyle="h4">Mentor</Label>
            </MentorHeaderCell>
            {MENTOR_AVAILABILITY_COLUMNS.map((col) => (
                <div key={col.day}>
                    <HeaderCell mb={"2px"}>
                        <Label fontStyle="h4">{col.day}</Label>
                    </HeaderCell>
                    <SlotGrid>
                        {col.time.map((slot) => (
                            <SlotCell key={`${col.day}-${slot.name}`}>
                                <HeaderCell>
                                    <Label fontStyle="h4">{slot.name}</Label>
                                </HeaderCell>
                            </SlotCell>
                        ))}
                    </SlotGrid>
                </div>
            ))}
        </HeaderGrid>
    );
};
